// ---------------------------------------------------------------------------
// releaseNotes/text — der Sprachwaechter (NEU-1). Reine Funktion.
// ---------------------------------------------------------------------------
// Eine Zeile in «Was ist neu» ist ein Satz fuer Menschen: Du-Form, Schweizer
// Schreibweise, sagt WAS jetzt anders ist und WO. Was hier abgewiesen wird,
// ist die Sprache der Code-Sessions — Baustein-Codes, snake_case, Backticks,
// Versionsnummern, «v6.» — und das ß. Die Zurueckweisung sagt im Klartext,
// was stoert; der Endpunkt gibt sie 1:1 zurueck.

export const RELEASE_NOTE_TEXT_MAX = 280;

export type TextPruefung =
  | { readonly ok: true }
  | { readonly ok: false; readonly grund: string };

const BAUSTEIN_CODE = /\b[A-Z]{2,5}-\d+\b/;
const SNAKE_CASE = /\b[a-z0-9]+(?:_[a-z0-9]+)+\b/;
const V6_PRAEFIX = /\bv6\./i;
const VERSIONSNUMMER = /\d+\.\d+\.\d+/;
const EMOJI = /\p{Extended_Pictographic}/u;

export function pruefeReleaseNoteText(text: string): TextPruefung {
  const t = text.trim();
  if (t.length === 0) {
    return { ok: false, grund: "Der Satz ist leer." };
  }
  if (t.length > RELEASE_NOTE_TEXT_MAX) {
    return {
      ok: false,
      grund: `Der Satz ist zu lang (${String(t.length)} von ${String(RELEASE_NOTE_TEXT_MAX)} Zeichen).`,
    };
  }
  const code = BAUSTEIN_CODE.exec(t);
  if (code) {
    return {
      ok: false,
      grund: `Baustein-Codes wie «${code[0]}» gehören nicht in einen Satz fürs Team.`,
    };
  }
  const snake = SNAKE_CASE.exec(t);
  if (snake) {
    return {
      ok: false,
      grund: `Technische Namen wie «${snake[0]}» gehören nicht in einen Satz fürs Team.`,
    };
  }
  if (t.includes("`")) {
    return { ok: false, grund: "Backticks gehören nicht in einen Satz fürs Team." };
  }
  if (V6_PRAEFIX.test(t)) {
    return {
      ok: false,
      grund: "«v6.» ist ein Code-Begriff — die Version steht im Feld «Version», nicht im Satz.",
    };
  }
  if (VERSIONSNUMMER.test(t)) {
    return {
      ok: false,
      grund: "Versionsnummern stehen im Feld «Version», nicht im Satz.",
    };
  }
  if (t.includes("ß")) {
    return { ok: false, grund: "Schweizer Schreibweise: «ss» statt «ß»." };
  }
  if (EMOJI.test(t)) {
    return { ok: false, grund: "Keine Emojis — das OS spricht in Worten." };
  }
  return { ok: true };
}
